import { Table } from "antd";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import DialogReport from "src/components/dialog/report";
import { Input } from "src/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select";
import { set_history_appointment } from "src/config/redux/slicer/expertise/expertiseSlicer";
import { onQueryAppointment } from "src/config/services/fellas/appointment.api";
import { AppointmentType } from "src/lib/types";
import { columns, homecare_columns } from "./columns";
import { Button } from "src/components/ui/button";
import { Search } from "lucide-react";
import MedicalReportPage from "./medical-report";
import { useLocation } from "react-router-dom";

export type PaginationAppointmentType = {
  count: number,
  next?: string
  previous?: string,
  results: AppointmentType[]
}

export default function AppointmentHistory() {
  const dispatch = useDispatch()
  const health_care_id = localStorage.getItem('health_care_id') || 0
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const mr = queryParams.get("mr")

  const [selected_table, setSelectedTable] = useState('Online')
  const { dialog } = useSelector((state: any) => state.AppointmentDialog)
  const { history_appointment } = useSelector((state: any) => state.Expertise)
  const [filter_patient, setFilterPatient] = useState('')
  const expertise = useSelector((state: any) => state.Expertise.value)

  const column = (
    selected_table === 'Homecare' ? homecare_columns
      : columns
  )
  const { limit, offset, count } = history_appointment
  const current = Math.round(offset / limit) + 1

  const { mutate: readAppointment, isLoading } = useMutation(async () => {
    const data = await onQueryAppointment({
      params: {
        limit: limit || 6,
        offset: offset || 0,
        health_care_id,
        status: 'Completed',
        patient: filter_patient,
        location: ['Homecare', 'Online'].includes(selected_table) ? selected_table : 'Offline'
      },
      hide_page_loading: true
    })
    return data
  }, {
    onSuccess: data => {
      const results = data.results.map((item, i) => ({ ...item, key: i }))
      const updated_data = ({ ...data, results, limit, offset })
      dispatch(set_history_appointment(updated_data))
    }
  })

  const handleTableParams = (pagination) => {
    if (pagination) {
      const { pageSize: limit, current } = pagination
      const offset = (current - 1) * limit
      dispatch(set_history_appointment({ ...history_appointment, offset, limit }))
    }
  }

  useEffect(() => {
    readAppointment()
  }, [selected_table, limit, offset, health_care_id]);

  return !mr ? (
    <div className="container space-y-4">
      {dialog.report && <DialogReport is_online={selected_table === 'Online'} />}
      <div className="flex flex-wrap justify-between gap-2">
        <div className="w-1/3 max-md:w-full">
          <Select onValueChange={val => setSelectedTable(val)}>
            <SelectTrigger><SelectValue>{selected_table}</SelectValue></SelectTrigger>
            <SelectContent>
              {['Online', expertise.offline_location?.label || 'Offline', 'Homecare'].map(item => (
                <SelectItem key={item} value={item}>{item}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); readAppointment() }} className="flex gap-2 md:w-1/3">
          <Input value={filter_patient || ''} onChange={e => setFilterPatient(e.target.value)} placeholder="Cari" />
          <Button size="icon" className="px-2" type="submit"><Search /></Button>
        </form>
      </div>
      <Table
        loading={isLoading}
        dataSource={history_appointment.results}
        columns={column}
        scroll={{ x: 1000 }}
        pagination={{
          current,
          total: count,
          pageSize: limit,
          hideOnSinglePage: true,
        }}
        onChange={handleTableParams}
      />
    </div>
  ) : (
    <MedicalReportPage />
  );
}
